/**
 * logger — dev-only debug channels + always-on error/warn.
 *
 * Rationale (iter114.5, code-quality audit):
 *   - Production bundles shipped to real users leaked ~16 `console.debug`
 *     lines (auth, credit-status, share, subscription polling, WS retries)
 *     and 2 `console.warn` lines. These weren't security-sensitive but they
 *     did leak file paths and inflated the console noise floor.
 *   - Instead of scrubbing per-callsite, all such calls now route through
 *     this tiny module. `debug` + `info` no-op outside development builds
 *     so the leak surface goes to zero without changing any callsite logic.
 *   - `warn` and `error` always fire — real problems must remain visible
 *     in production for user-side troubleshooting and Sentry-equivalent
 *     hookup later.
 *
 * Bundle impact: this file is < 400 bytes gzipped and Terser inlines the
 * IS_DEV constant so `logger.debug` calls fold away entirely in prod.
 */

// process.env.NODE_ENV is inlined by Create React App / Webpack at build
// time as a literal string, which lets Terser dead-code-eliminate the
// no-op branches in production bundles.
const IS_DEV = typeof process !== 'undefined'
  && process.env
  && process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  debug: IS_DEV ? console.debug.bind(console) : noop,
  info: IS_DEV ? console.info.bind(console) : noop,
  log: IS_DEV ? console.log.bind(console) : noop,
  // Warn and error always fire — production troubleshooting depends on them.
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

export default logger;
